module.exports = __webpack_public_path__ + "static/img/cont45_02.5e640e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_02.jpg
// module id = CeXe
// module chunks = 0